<template>
    <section>
        <template>
            <bstep0 v-if="isPage == 0" />
            <bstep1 v-if="isPage == 1" />
            <bstep2 v-if="isPage == 2" />
            <bstep3 v-if="isPage == 3" />
            <bstep4 v-if="isPage == 4" />
            <bstep5 v-if="isPage == 5" />
            <bstep6 v-if="isPage == 6" />
            
            <gstep2 v-if="isPage == 7" />
            <gstep4 v-if="isPage == 8" />
            <gstep5 v-if="isPage == 9" />
            <gstep6 v-if="isPage == 10" />
            <gstep7 v-if="isPage == 11" /> 
            <gstep8 v-if="isPage == 12" />
            <personal-detail v-if="isPage == 13" />
        </template>
        
        <div class="row my-3" >
              <div class="col-lg-6 offset-lg-3 col-12 text-center p-0">
                 <progress-step @next-page="nextPage" @back-page="backPage" @submit-btn="submitDetail" :page="isPage" /> 
              </div>
        </div>

    </section>
</template>
<script>

import Bstep0 from './Components/Borrower/Step0.vue'
import Bstep1 from './Components/Borrower/Step1.vue'
import Bstep2 from './Components/Borrower/Step2.vue'
import Bstep3 from './Components/Borrower/Step3.vue'
import Bstep4 from './Components/Borrower/Step4.vue'
import Bstep5 from './Components/Borrower/Step5.vue'
import Bstep6 from './Components/Borrower/Step6.vue'
import Gstep2 from './Components/Guarantor/Step2.vue'
import Gstep3 from './Components/Guarantor/Step3.vue'
import Gstep4 from './Components/Guarantor/Step4.vue'
import Gstep5 from './Components/Guarantor/Step5.vue'
import Gstep6 from './Components/Guarantor/Step6.vue'
import Gstep7 from './Components/Guarantor/Step7.vue'
import Gstep8 from './Components/Guarantor/Step8.vue'
import PersonalDetail from './Components/Form/PersonalDetail.vue'
import ProgressStep from './Components/ProgressStep.vue'
import { mapActions } from 'vuex'
export default {
  name: 'Nimcap',
  components: {
    Bstep0,
    Bstep1,
    Bstep2,
    Bstep3,
    Bstep4,
    Bstep5,
    Bstep6,
    Gstep2,
    Gstep3,
    Gstep4,
    Gstep5,
    Gstep6,
    Gstep7,
    Gstep8,
    PersonalDetail,
    ProgressStep
  },
  data () {
    return {
      isPage: 0
    }
  },
  created () {
    let payload = {
      main_key: 'professionalId',
      value: 2514
    }
    this.SET_EL_VALUE(payload)
  },
  methods: {
    ...mapActions({
      SET_EL_VALUE: 'nimcap/SET_EL_VALUE'
    }),
    nextPage (n) {
      this.isPage += n
    },
    backPage (n) {
      if (this.isPage > 0) this.isPage -= n
    },
    submitDetail () {
      this.isPage = 0
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/nimcap/index.vue